var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path5, _circle7, _path6, _circle8, _path7, _circle9, _circle0, _path8, _path9, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMediaScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 182.5L163.5 121L255 117L263 207L186 182.5",
    stroke: "#192657",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59 129.5L95 183.5L81 237.5",
    stroke: "#192657",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182 235.5L189 179.5L229.5 171.5",
    stroke: "#192657",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.986 92.1465L161.552 128.981L107.341 115.821",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 181.5,
    r: 34.5,
    fill: "#ECEFF3",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 120,
    r: 31,
    fill: "#F58120",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.5,
    cy: 179.5,
    r: 25.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 263.5,
    cy: 208.5,
    r: 25.5,
    fill: "#F58120",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 119.5,
    r: 38.5,
    fill: "#528FF5",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 171,
    r: 10,
    fill: "#192657"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112 200C112 195.491 110.209 191.167 107.021 187.979C103.833 184.791 99.5087 183 95 183C90.4913 183 86.1673 184.791 82.9792 187.979C79.7911 191.167 78 195.491 78 200L95 200H112Z",
    fill: "#192657"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 251.823,
    cy: 106.765,
    r: 11.7647,
    fill: "#192657"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M273 140.882C273 135.578 270.893 130.491 267.142 126.74C263.391 122.989 258.304 120.882 253 120.882C247.696 120.882 242.609 122.989 238.858 126.74C235.107 130.491 233 135.578 233 140.882L253 140.882H273Z",
    fill: "#192657"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 166.235,
    cy: 112.176,
    r: 7.64706,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M180 134.353C180 130.905 178.63 127.599 176.192 125.161C173.754 122.723 170.448 121.353 167 121.353C163.552 121.353 160.246 122.723 157.808 125.161C155.37 127.599 154 130.905 154 134.353L167 134.353H180Z",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.353,
    cy: 171.765,
    r: 6.47059,
    fill: "#528FF5"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 262.353,
    cy: 200.471,
    r: 6.47059,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199 190.529C199 187.612 197.841 184.814 195.778 182.751C193.715 180.688 190.917 179.529 188 179.529C185.083 179.529 182.285 180.688 180.222 182.751C178.159 184.814 177 187.612 177 190.529L188 190.529H199Z",
    fill: "#528FF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M274 219.235C274 216.318 272.841 213.52 270.778 211.457C268.715 209.394 265.917 208.235 263 208.235C260.083 208.235 257.285 209.394 255.222 211.457C253.159 213.52 252 216.318 252 219.235L263 219.235H274Z",
    fill: "white"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 242,
    r: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 126,
    r: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 181,
    cy: 241,
    r: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 235,
    cy: 170,
    r: 5,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 218.453,
    cy: 90.0925,
    r: 5,
    transform: "rotate(89.1101 218.453 90.0925)",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.092,
    cy: 115.092,
    r: 5,
    transform: "rotate(89.1101 103.092 115.092)",
    stroke: "#192657",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36.5H16.5V161",
    stroke: "#192657",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43V147C48 140.5 23 88.5 48 77C68 67.8 73.6667 50.5 74 43H23Z",
    fill: "#F58120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.5 26L146.429 38.0922L159.143 38.0922L148.857 45.5656L152.786 57.6578L142.5 50.1844L132.214 57.6578L136.143 45.5656L125.857 38.0922L138.571 38.0922L142.5 26Z",
    fill: "#F58120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.5 26L176.429 38.0922L189.143 38.0922L178.857 45.5656L182.786 57.6578L172.5 50.1844L162.214 57.6578L166.143 45.5656L155.857 38.0922L168.571 38.0922L172.5 26Z",
    fill: "#F58120"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.5 26L206.429 38.0922L219.143 38.0922L208.857 45.5656L212.786 57.6578L202.5 50.1844L192.214 57.6578L196.143 45.5656L185.857 38.0922L198.571 38.0922L202.5 26Z",
    fill: "#F58120"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.5 26L236.429 38.0922L249.143 38.0922L238.857 45.5656L242.786 57.6578L232.5 50.1844L222.214 57.6578L226.143 45.5656L215.857 38.0922L228.571 38.0922L232.5 26Z",
    fill: "#F58120"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M262.5 29.2361L265.478 38.4012L265.702 39.0922H266.429L276.066 39.0922L268.269 44.7566L267.682 45.1836L267.906 45.8746L270.884 55.0398L263.088 49.3754L262.5 48.9483L261.912 49.3754L254.116 55.0398L257.094 45.8746L257.318 45.1836L256.731 44.7566L248.934 39.0922L258.571 39.0922H259.298L259.522 38.4012L262.5 29.2361Z",
    stroke: "#192657",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 283,
    width: 14,
    height: 14,
    fill: "#192657"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 283,
    width: 14,
    height: 14,
    fill: "#192657"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 187,
    y: 283,
    width: 14,
    height: 14,
    fill: "#192657"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 283,
    width: 14,
    height: 14,
    fill: "#192657"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 283,
    width: 14,
    height: 14,
    fill: "#192657"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106 44.9998C178.667 12.8331 323.2 -18.0002 320 116C316 283.5 184 399.5 63.9999 285C-56.0001 170.5 37.9999 73.5 86.9999 75C136 76.5 265.5 132 230 238.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaScore);
export default __webpack_public_path__ + "static/media/SocialMediaScore.3108e7f204c3cfe473ff69d666939f3e.svg";
export { ForwardRef as ReactComponent };